import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

const styles = () => ({
  smallColumn: {
    flexBasis: '18%',
  },
  bigColumn: {
    flexBasis: '82%',
    lineHeight: '2rem',
  },
});

const ExpansionPanelView = (props) => {
  const {
    title, description, classes, children, disabled,
  } = props;
  return (
    <ExpansionPanel disabled={disabled}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.smallColumn} variant="h6">{title}</Typography>
        <Typography className={classes.bigColumn} variant="subtitle1">{description}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>{children}</ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

ExpansionPanelView.defaultProps = {
  disabled: false,
};

ExpansionPanelView.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(ExpansionPanelView);
